import _get from 'lodash/get';

/**
 * ? Type of SERVICES && ACTIVITY are automatically INTERNAL
 * ? -- returns SLUG as URL
 * ? If URL includes 'crediblemind.com' string, it is assumed to be INTERNAL
 * ? -- returns URL path without 'crediblemind.com'
 */

function isValidHttpUrl(string) {
  let url;
  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }
  return url.protocol === 'http:' || url.protocol === 'https:';
}

const analyzeClientResource = item => {
  let url = _get(item, 'url') || '';
  const slug = _get(item, 'slug') || '';
  const contentTypeSysId = (
    _get(item, 'sys.contentType.sys.id') || ''
  ).toLowerCase();
  const typename = (_get(item, '__typename') || '').toLowerCase();
  const type = (_get(item, 'type') || '').toLowerCase();
  const urlObject = isValidHttpUrl(url) ? new URL(url) : {};
  const isCMLink =
    _get(urlObject, 'hostname') === 'crediblemind.com' || url.startsWith('/');

  const checker = [contentTypeSysId, typename, type];
  const isActivity = checker.includes('activity');
  const isService = checker.includes('services');
  const isInternal = isActivity || isService || isCMLink;

  url =
    isInternal && isActivity
      ? `/articles/${slug}`
      : isInternal && isService
      ? `/services/${slug}`
      : url.replace('https://crediblemind.com', '');

  return {
    isInternal,
    url,
  };
};

export default analyzeClientResource;
